import type { AppCopy } from '../catalogs';

export const plAppCopy = {
  welcomeHeading: 'Jak mogę Ci dzisiaj pomóc?',
  thinking: 'Myślenie',
  scrollToBottom: 'Przewiń w dół',
  reasoning: 'Rozumowanie',
  reasoningInProgress: 'w toku',
  citationPages: 'Strony {first}–{last}',
  citationTitle: 'Fragment źródła',
  citationLoading: 'Ładowanie źródła…',
  citationUnavailable: 'Cytowany tekst jest niedostępny lub nie masz już do niego dostępu.',
  citationOpen: 'Otwórz źródło',
  citationCopied: 'Cytat skopiowany',
  copy: 'Kopiuj',
  more: 'Więcej',
  tryAgain: 'Spróbuj ponownie',
  answerTruncated: 'Odpowiedź osiągnęła limit długości i została ucięta.',
  continueAnswer: 'Kontynuuj odpowiedź',
  exportMarkdown: 'Eksportuj jako Markdown',
  edit: 'Edytuj',
  cancel: 'Anuluj',
  update: 'Aktualizacja',
  previous: 'Poprzedni',
  next: 'Następny',
  messagePlaceholder: 'Wyślij wiadomość…',
  projectHomePlaceholder: 'Nowy czat: {project}',
  sharedChatEveryone: 'Wszyscy w {company} mogą czytać ten czat',
  sharedChatOnePerson: '1 osoba może czytać ten czat',
  sharedChatPeople: 'Liczba osób, które mogą czytać ten czat: {count}',
  forkedChatPlaceholder: 'Kontynuuj z własnymi połączeniami…',
  newAnswer: 'Nowa odpowiedź',
  messageInput: 'Wejście wiadomości',
  sendMessage: 'Wyślij wiadomość',
  stopGenerating: 'Przestań generować',
  addAttachment: 'Dodaj załącznik',
  removeFile: 'Usuń plik',
  attachmentPreview: 'Podgląd załącznika',
  imageAttachmentPreview: 'Podgląd załącznika obrazu',
  image: 'Obraz',
  openLink: 'otwórz łącze',
  document: 'Dokument',
  file: 'Plik',
  attachment: 'załącznik',
  uploadFailed: 'przesyłanie nie powiodło się',
  uploading: 'przesyłanie',
  toolIncomplete: 'Nieukończone',
  toolActivity: 'Aktywność',
  activityThinking: 'Myśli…',
  activityWriting: 'Pisze…',
  activityWaiting: 'Oczekiwanie na Twoją zgodę',
  activityStopped: 'Zatrzymano',
  activityCouldNotFinish: 'Nie udało się dokończyć',
  activitySources: 'źródeł',
  activityShowThinking: 'Pokaż myślenie',
  activityOpen: 'Otwórz aktywność',
  activitySteps: 'Kroki',
  activitySourcesTab: 'Źródła',
  activityUnavailable: 'Ta aktywność jest niedostępna.',
  activityInput: 'Wejście',
  activityOutput: 'Wyjście',
  activityNoSources: 'Odpowiedź nie zawiera cytowanych źródeł.',
  activityApprovedByReply: 'Zatwierdzone Twoją odpowiedzią',

  toolRunning: 'W toku',
  toolComplete: 'Ukończono',
  toolNeedsApproval: 'Wymaga zatwierdzenia',
  toolInput: 'Dane wejściowe',
  toolCall: 'wywołanie narzędzia',
  toolCalls: 'wywołania narzędzi',
  openMenu: 'Otwórz menu',
  closeMenu: 'Zamknij menu',
  close: 'Zamknij',
  showInTextField: 'Pokaż w polu tekstowym',
  settings: 'Ustawienia',
  appearance: 'Wygląd',
  themeLight: 'Jasny',
  themeDark: 'Ciemny',
  themeSystem: 'Systemowy',
  themeChoiceHelp:
    'Obowiązuje na wszystkich Twoich urządzeniach. Opcja „Systemowy” dostosowuje się do jasnego lub ciemnego trybu każdego urządzenia.',
  themeSaveFailed: 'Nie udało się zapisać wyglądu, więc pozostał bez zmian. Spróbuj ponownie.',
  toolUsed: 'Użyte narzędzie',
  toolCancelled: 'Anulowane narzędzie',
  toolResult: 'Wynik:',
  toolError: 'Błąd:',
  toolCancelledReason: 'Powód anulowania:',
  approvalAllow: 'Zezwól',
  approvalAlwaysAllow: 'Zawsze pozwalaj',
  approvalDeny: 'Odmów',
  approvalAlwaysDeny: 'Zawsze odmawiaj',
  approvalConfirm: 'Potwierdź',
  approvalBack: 'Powrót',
  approvalApprovedResult: 'Zatwierdzone przez użytkownika',
  approvalDeniedResult: 'Użytkownik odmówił wykonania narzędzia',
  logout: 'Wyloguj się',
  loginOrCreateAccount: 'Zaloguj się / Utwórz konto',
  newChat: 'Nowy czat',
  untitledChat: 'Czat bez tytułu',
  previousChats: 'Poprzednie czaty',
  openChat: 'Otwórz czat {title}',
  moreActionsForChat: 'Więcej akcji dla {title}',
  chatActions: 'Działania na czacie',
  closeChatActions: 'Zamknij działania na czacie',
  deleteChatQuestion: 'Usunąć czat?',
  deleteChatDescription: 'Czat „{title}” zostanie trwale usunięty.',
  deleteChat: 'Usuń czat',
  keepChat: 'Zachowaj czat',
  delete: 'Usuń',
  deleting: 'Usuwanie…',
  chatDeleteFailed: 'Nie można usunąć czatu. Spróbuj ponownie.',
  settingsDescription: 'Dostosuj sposób działania asystenta.',
  settingsDesktopDescription: 'Dostosuj sposób, w jaki asystent reaguje na Ciebie.',
  personalization: 'Personalizacja',
  personalizationDescription:
    'Dostosuj instrukcje, których asystent będzie przestrzegać przy każdej odpowiedzi.',
  languageAndRegion: 'Język i region',
  languageAndRegionDescription: 'Wybierz język i strefę czasową.',
  memories: 'Wspomnienia',
  memoriesDescription: 'Przeglądaj, edytuj lub usuwaj informacje, które asystent o Tobie pamięta.',
  account: 'Konto',
  accountDescription: 'Zarządzaj kontem i trwałym usunięciem swoich danych.',
  backToSettings: 'Powrót do ustawień',
  closeSettings: 'Zamknij ustawienia',
  settingsCategories: 'Kategorie ustawień',
  yourSettings: 'Twoje ustawienia',
  dataAndAccount: 'Dane i konto',
  viewAndManageMemories: 'Przeglądaj i zarządzaj tym, co pamięta asystent',
  loginToUseMemories: 'Zaloguj się, aby korzystać ze wspomnień',
  manageOrDeleteAccount: 'Zarządzaj lub usuń konto',
  unsavedChanges: 'Masz niezapisane zmiany',
  unsavedCloseDescription: 'Zamknięcie ustawień spowoduje odrzucenie zmian na tej stronie.',
  unsavedBackDescription: 'Powrót spowoduje odrzucenie zmian na tej stronie.',
  continueEditing: 'Kontynuuj edycję',
  discardChanges: 'Odrzuć zmiany',
  saveChanges: 'Zapisz zmiany',
  localSettingsNote: 'Zapisano w tej przeglądarce. Zaloguj się, aby zapisać na swoim koncie.',
  personality: 'Osobowość',
  personalityHelp: 'Niestandardowe instrukcje, których asystent przestrzega przy każdej odpowiedzi',
  personalityPlaceholder:
    'Na przykład: Bądź zwięzły i konkretny. Mieszkam w Göteborgu i lubię wegetariańskie jedzenie.',
  timezone: 'Strefa czasowa',
  searchTimezone: 'Wyszukaj strefy czasowe…',
  automaticBrowser: 'Automatycznie (przeglądarka)',
  saved: 'Zapisano {date}',
  addMemory: 'Dodaj wspomnienie',
  newMemory: 'Nowe wspomnienie',
  memoryPlaceholder: 'Na przykład: Wolę krótkie, konkretne odpowiedzi.',
  editMemory: 'Edytuj wspomnienie',
  saveMemory: 'Zapisz wspomnienie',
  deleteMemory: 'Usuń wspomnienie',
  memorySaveFailed: 'Nie udało się zapisać pamięci. Spróbuj ponownie.',
  memoryLimitReached: 'Możesz zapisać maksymalnie 50 wspomnień. Usuń jedno, zanim dodasz kolejne.',
  memoryInvalid: 'Wspomnienia nie mogą zawierać linków. Usuń link i spróbuj ponownie.',
  memoryDeleteFailed: 'Nie można usunąć pamięci. Spróbuj ponownie.',
  memoryLoadFailed: 'Nie udało się załadować wspomnień.',
  loadingMemories: 'Ładowanie wspomnień…',
  emptyMemories:
    'Asystent zapisuje wspomnienia o Tobie, gdy rozmawiasz — o tym, co lubisz, gdzie mieszkasz i co robisz. Tutaj możesz je przeglądać, edytować i usuwać.',
  deleteAccountHelp: 'Trwale usuń konto i wszystkie powiązane czaty, wspomnienia i ustawienia.',
  deleteAccount: 'Usuń konto',
  deleteAccountQuestion: 'Trwale usunąć konto?',
  deleteAccountDescription:
    'Wszystkie czaty, wiadomości, wspomnienia, ustawienia i dane logowania zostaną usunięte. Tej akcji nie można cofnąć.',
  deleteAccountConfirm: 'Tak, usuń moje konto',
  accountDeleteFailed: 'Nie udało się usunąć konta. Nic nie zostało usunięte — spróbuj ponownie.',
  logoutEverywhereTitle: 'Wszystkie urządzenia',
  logoutEverywhereHelp:
    'Wyloguj się na wszystkich urządzeniach i w przeglądarkach, w których Twoje konto jest otwarte, również na tym.',
  logoutEverywhere: 'Wyloguj się wszędzie',
  logoutEverywhereQuestion: 'Wylogować się na wszystkich urządzeniach?',
  logoutEverywhereDescription:
    'Trzeba będzie zalogować się ponownie na wszystkich urządzeniach i w przeglądarkach, również na tym. Twoje czaty i ustawienia pozostaną bez zmian.',
  loggingOut: 'Wylogowywanie…',
  logoutEverywhereFailed:
    'Nie udało się potwierdzić, że wylogowano Cię wszędzie. Spróbuj ponownie lub sprawdź na innym urządzeniu, czy nadal jesteś zalogowany.',
  settingsSaveFailed: 'Nie można zapisać ustawień. Spróbuj ponownie.',
  customInstructions: 'Niestandardowe instrukcje',
  notSet: 'Nie ustawiono',
  automaticLanguage: 'Język automatyczny',
  automaticTimezone: 'automatyczna strefa czasowa',
  appLanguage: 'Język aplikacji',
  appLanguageHelp:
    'Steruje całym interfejsem aplikacji i datami. Odpowiedzi asystenta nadal są udzielane w języku, w którym piszesz.',
  automaticBrowserLanguage: 'Automatyczny (język przeglądarki)',
  previousLanguageChoice: 'Poprzedni wybór: {language} ({locale})',
  previousLanguageChoiceCode: 'Poprzedni wybór ({locale})',
  canvasCopyLink: 'Kopiuj link',
  canvasLinkCopied: 'Link skopiowany',
  actionUpdatedWithEdits: 'Zaktualizowano o Twoje zmiany',
  activityStepsDone:
    'one:krok ukończony|few:kroki ukończone|many:kroków ukończonych|other:kroku ukończonego',
  activityResultsCount: 'one:wynik|few:wyniki|many:wyników|other:wyniku',
  canvasCopyLinkFailed: 'Nie udało się skopiować linku',
  canvasOpenInAgent: 'Otwórz w aplikacji {agent}',
  canvasExpand: 'Rozwiń',
  canvasExitFullView: 'Zamknij pełny widok',
  webSourceUnread:
    'Link w tej odpowiedzi. Poneva nie czytała tej strony, więc nie ma tu nic do pokazania.',
  webSourceOpenOriginal: 'Otwórz oryginał',
  toolProgressSettings: 'Zmieniam Twoje ustawienia…',
  toolProgressAgent: 'Tworzę agenta…',
  toolProgressConnections: 'Szukam opcji połączenia…',
  toolProgressResult: 'Przygotowuję wynik…',
  toolProgressClarification: 'Przygotowuję doprecyzowanie…',
  toolProgressKnowledge: 'Przygotowuję propozycję aktualizacji wiedzy…',
  toolProgressQuestion: 'Przygotowuję pytanie do Ciebie…',
  toolProgressSkill: 'Kształtujemy Twój Skill…',
  toolErrorSettings: 'Twoje ustawienia nie zostały zmienione.',
  toolErrorAgent: 'Nie udało się utworzyć agenta.',
  toolErrorConnections: 'Nie udało się wczytać opcji połączenia.',
  toolErrorResult: 'Wynik nie został zapisany.',
  toolErrorClarification: 'Nie udało się przygotować doprecyzowania.',
  toolErrorKnowledge: 'Nie udało się przygotować propozycji aktualizacji wiedzy.',
  toolErrorQuestion: 'Nie udało się przygotować pytania.',
  toolErrorSkill: 'Nie udało się zapisać wersji roboczej Skilla.',
  toolErrorOpenSettings: 'Otwórz Ustawienia',
  toolErrorOpenAgents: 'Otwórz Agentów',
  toolErrorOpenConnections: 'Otwórz Połączenia',
  toolStepIncomplete: 'Ten krok nie został ukończony.',
  toolEarlierAttemptsFailed:
    'one:wcześniejsza próba się nie powiodła|few:wcześniejsze próby się nie powiodły|many:wcześniejszych prób się nie powiodło|other:wcześniejszej próby się nie powiodło',
} satisfies AppCopy;
